import ToursMixin from '@/mixins/tours.mixin.js'

export default {
  data() {
    return {
      dataTransformersSetup: {
        Tours: {
          transform: (tour) => {
            return this.realVisits(tour)
          },
          transformAll: (tours) => {
            return tours.map(x => { return this.dataTransformers.tours.transform(x) })
          }
        }
      }
    }
  },
  mixins: [ToursMixin]
}
